import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Storage } from '@ionic/storage';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Client } from '../entities/client';
import { ClientStorage } from '../entities/clientStorage';
import { Router } from '@angular/router';

import { LoginAnonService } from './loginanon.service';
import { Device } from '@ionic-native/device/ngx';

@Injectable({
  providedIn: 'root',
})
export class AnonTokenService {
  usertokens: string;
  token: string;
  user: string;
  client: Client;
  clientStorage: ClientStorage;
  authenticationState = new BehaviorSubject(false);

  constructor(
    private storage: Storage,
    private helper: JwtHelperService,
    private router: Router,
    private loginServices: LoginAnonService,
    private device: Device
  ) {}

  ActualizarToken(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.storage.get('public').then((client) => {
        if (client) {
          this.clientStorage = client;
          this.token = this.clientStorage.Token;
          this.client = this.clientStorage.RClient;
          const expirationDate = this.helper.getTokenExpirationDate(this.token);
          const isExpired = this.helper.isTokenExpired(this.token);

          if (isExpired) {
            //Se tramita el token
            this.loginServices.GetToken(this.device.uuid).subscribe((task) => {
              const clt = task['Result'];
              const isError = task['isError'];
              if (isError === true) {
                //Deberia ir una alerta, de "No hay comunicacion con servidor y no se puede continuar"
                reject('');
              }
              if (clt != null) {
                this.clientStorage.Token = clt['Token'];
                this.token = clt['Token'];
                this.storage.set('public', this.clientStorage);

                resolve(this.clientStorage);
              }
            });
          } else {
            resolve(this.clientStorage);
          }
        } else {
          this.loginServices.GetToken(this.device.uuid).subscribe((task) => {
            const clt = task['Result'];
            const isError = task['isError'];
            if (isError === true) {
              //Deberia ir una alerta, de "No hay comunicacion con servidor y no se puede continuar"
              reject('');
            }
            if (clt != null) {
              this.clientStorage = clt;
              this.clientStorage.Token = clt['Token'];
              this.token = clt['Token'];
              this.storage.set('public', this.clientStorage);

              resolve(this.clientStorage);
            }
          });

          //this.router.navigate(['/login', {  }]);
        }
      });
    });
  }
}
